import React from 'react'
import qs from 'qs';
import { connect } from 'react-redux'
import { change as changeFieldValue } from 'redux-form';
import Titulo from '../comum/Titulo';
import ConfiguracaoItinerarioReservaBpe from './ConfiguracaoItinerarioReservaBpe';
import emitirBpeReserva from '../../actions/reserva/emitirBpeReserva'
import { buscarReservasConfiguracaoBpeItinerario }
  from '../../actions/reserva/buscarReservasItinerario';
import CabecalhoRodapeTabela from '../comum/CabecalhoRodapeTabela';
import PaginacaoItinerarioReservaBpe from './PaginacaoItinerarioReservaBpe';
import BotoesPaginacaoItinerarioReservaBpe from './BotoesPaginacaoItinerarioReservaBpe';
import { alterouPagina } from '../../util/filtros';
import { alterouEmpresa } from '../../actions/empresa/alterarEmpresaSelecionada';
import determinarPaginaAtual from '../../actions/reserva/determinarPaginaAtualReservaBpe'
import {PERFIL_ADMIN, getAdminEmpresa, getGestorOperacoes} from '../../security/securityContext';
import Autorizacao from '../../security/Autorizacao';


export const CabecalhoTabela = () => (
  <div id="header-tabela" className="lista-table d-md-block d-lg-block d-xl-block d-none d-sm-none">
    <div className="row cabecalho-desktop">
      <div className="col-lg-1 col-xl-1">N° bilhete</div>
      <div className="col-lg-1 col-xl-1">N° pedido</div>
      <div className="col-lg-2 col-xl-2">Situação Reserva</div>
      <div className="col-lg-2 col-xl-2">Cidade Origem</div>
      <div className="col-lg-2 col-xl-2">Cidade Destino</div>
      <div className="col-lg-2 col-xl-2">Nome Passageiro</div>
      <div className="col-lg-2 col-xl-2">Situação Bpe</div>
      <div className="col-lg-2 col-xl-2">Emitir Bpe</div>
    </div>
  </div>
);


export class PainelConfiguracaoItinerarioReservasBpe extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      codigoItinerarioSelecionado: null,
      idReservas: [],
      paginaRetorno: ''
    };
  }


  componentDidMount() {
    const parametros = qs.parse(this.props.history.location.search, { ignoreQueryPrefix: true });
    this.setState({
      paginaRetorno: parametros.paginaRetorno
    })
    if (parametros.codigoItinerario) {
      this.setState({
        codigoItinerarioSelecionado: parametros.codigoItinerario,
      }
      )
      this.props.buscarReservasConfiguracaoBpeItinerario(parametros.codigoItinerario, this.props.empresaSelecionada.id, this.props.paginaAtual, this.props.registrosPorPagina)
    }
  }

  UNSAFE_componentWillMount() {
    this.props.determinarPaginaAtual(1)
}

  componentDidUpdate(prevProps) {
      if(alterouEmpresa(this.props, prevProps) || alterouPagina(this.props, prevProps)) {
        this.props.buscarReservasConfiguracaoBpeItinerario(this.state.codigoItinerarioSelecionado, this.props.empresaSelecionada.id, this.props.paginaAtual, this.props.registrosPorPagina)
      }
  }

  determinarUrlRetorno = () => {
    const {paginaRetorno} = this.props;

    if (paginaRetorno === '/painel-itinerarios' || paginaRetorno === '/painel-embarque-passageiros') {
      return paginaRetorno;
    } else {
      return '/painel-embarque-passageiros';
    }
  }

  emitirBpeReservasSelecionadas(idsReservasSelecionados) {
    this.props.emitirBpeReserva(idsReservasSelecionados, this.props.empresaSelecionada.id)
      .then(() => {
        this.props.buscarReservasConfiguracaoBpeItinerario(this.state.codigoItinerarioSelecionado, this.props.empresaSelecionada.id, this.props.paginaAtual, this.props.registrosPorPagina)
        this.setState({ idReservas: [] })
      });
  }

  exibirTabelaReservas() {
    if (this.props.reservasBpe && this.props.reservasBpe.total > 0) {
      return (<div>
        <CabecalhoRodapeTabela OpcoesPaginacao={PaginacaoItinerarioReservaBpe}
          BotoesPaginacao={BotoesPaginacaoItinerarioReservaBpe}>
          <CabecalhoTabela />
          <div className="lista-tabela-dados">
            {this.exibirReservas()}
          </div>
        </CabecalhoRodapeTabela>
      </div>
      )
    }
    return <div>Nenhuma reserva cadastrada.</div>;
  }

  adicionarReservas(reservaId) {
    let reservasIds = this.state.idReservas;
    const jaExisteReserva = reservasIds.filter(it => it === reservaId)
    if (jaExisteReserva.length > 0) {
      reservasIds = reservasIds.filter(it => it !== reservaId)
      this.setState({ idReservas: reservasIds })
    } else {
      reservasIds.push(reservaId);
      this.setState({ idReservas: reservasIds })
    }
  }

  adicionarTodasReservas(idReservas) {
    this.setState({ idReservas: idReservas })
  }

  exibirReservas() {
    return this.props.reservasBpe.reservas
      .map((reservasBpe, index) => <ConfiguracaoItinerarioReservaBpe key={`reservas_bpe_${reservasBpe.reservaId}`}
        reservasBpe={reservasBpe}
        adicionarReservas={this.adicionarReservas.bind(this)}
        idReservas={this.state.idReservas}
        indice={index} />)
  }

  exibirBotoes(reservasBpe) {
    const semReservaParaRetransmitir = reservasBpe ? reservasBpe.idsReservas.length === 0 : true;
    return (
      <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
      getAdminEmpresa(this.props.empresaSelecionada.id),
      getGestorOperacoes(this.props.empresaSelecionada.id)]}>
      <div className="row">
        <div className="col-12 mb-5">
          <div className="float-right">
            <button className="vx-btn-primary"
              onClick={() => this.emitirBpeReservasSelecionadas(this.state.idReservas)}
              disabled={this.state.idReservas.length === 0}>
              Retransmitir BPe
            </button>
          </div>
          <div className="float-right mr-3">
            <button className="vx-btn-secondary"
              onClick={() => this.adicionarTodasReservas(reservasBpe.idsReservas)}
              disabled={semReservaParaRetransmitir}>
              Selecionar tudo
            </button>
          </div>
        </div>
      </div>
      </Autorizacao>
    )
  }

  render() {
    return (
      <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
        getAdminEmpresa(this.props.empresaSelecionada.id),
        getGestorOperacoes(this.props.empresaSelecionada.id)]}
        empresaSelecionada={this.props.empresaSelecionada}>
      <div className="container-padrao">
        <Titulo texto="Gerenciar Configuração BPe Reservas" urlRetorno={this.determinarUrlRetorno()} />
        {this.exibirBotoes(this.props.reservasBpe)}
        {this.exibirTabelaReservas()}
      </div>
      </Autorizacao>
    )
  }
}


export const mapStateToProps = (state) => {
  return {
    reservasBpe: state.reservasBpe.reservasBpe,
    empresaSelecionada: state.empresaSelecionada,
    paginaAtual: state.paginaAtualReservaBpe,
    registrosPorPagina: state.registrosPorPaginaReservaBpe,
    changeFieldValue,
  }
};


export default connect(mapStateToProps,
  {
    buscarReservasConfiguracaoBpeItinerario,
    emitirBpeReserva,
    determinarPaginaAtual
  })(PainelConfiguracaoItinerarioReservasBpe)
